import MuCvOne from './muCvOne'

const muCvOne = {
  install: function (Vue) {
    Vue.component('MuCvOne', MuCvOne)
  }
}
export default muCvOne



// WEBPACK FOOTER //
// ./src/components/muCvOneIndex.js